export default "__VITE_ASSET__Es8VLnYJ__"